import React, { PropsWithChildren } from 'react';
import { ThemeProvider as UnifiedAlphaThemeProvider } from '@oneaudi/unified-web-alpha-common';
import { ThemeProvider as StyledThemeProvider, useTheme } from 'styled-components';
import { ALPHA_THEME } from './alphaTheme';

const isBrowser = typeof window !== 'undefined';

const DesignSystemThemeProviderAlpha: React.FC<PropsWithChildren> = ({ children }) => {
  const { iconBasePath } = useTheme() as { iconBasePath?: string };

  const resolvedIconBasePath =
    iconBasePath && !/^(\/|https?:\/\/)/.test(iconBasePath) ? `/${iconBasePath}` : iconBasePath;

  if (isBrowser) {
    return (
      <UnifiedAlphaThemeProvider
        theme={{
          name: 'dark',
          ...(resolvedIconBasePath ? { iconBasePath: resolvedIconBasePath } : {}),
        }}
      >
        <StyledThemeProvider theme={ALPHA_THEME}>{children}</StyledThemeProvider>
      </UnifiedAlphaThemeProvider>
    );
  }
  return <>{children}</>;
};

export default DesignSystemThemeProviderAlpha;
